import { render, staticRenderFns } from "./CountriesStats.vue?vue&type=template&id=34401261&scoped=true&"
import script from "./CountriesStats.vue?vue&type=script&lang=js&"
export * from "./CountriesStats.vue?vue&type=script&lang=js&"
import style0 from "./CountriesStats.vue?vue&type=style&index=0&id=34401261&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34401261",
  null
  
)

export default component.exports